import React from 'react';

export const PlusIconWithCircle: React.FC<{ color?: string; className?: string }> = ({
  color = '#666666',
  className,
}) => {
  return (
    <svg
      className={className}
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='9' cy='9.25' r='8.25' stroke={color} strokeWidth='1.5' />
      <path d='M8.25 4.75H9.75V8.5H13.5V10H9.75V13.75H8.25V10H4.5V8.5H8.25V4.75Z' fill={color} />
    </svg>
  );
};
